(function () {
  'use strict';

  if (!window.twcPlpData) return;

  var products = window.twcPlpData.products = window.twcPlpData.products || {};
  var ribbonColor = window.twcPlpData.ribbonColor || '#6B2737';
  var fetchPromises = {};
  var SOLD_OUT_LABEL = 'Sold out';

  function formatMoney(amount) {
    if (typeof amount !== 'number') amount = parseFloat(amount);
    if (isNaN(amount)) return '';
    // Clean up binary floating-point error before rounding. e.g.
    // 16.50 * 0.95 evaluates to 15.674999999999999, which toFixed(2) would
    // round DOWN to 15.67; toPrecision(12) restores 15.675 so it rounds up to
    // 15.68 as expected.
    var corrected = Number(amount.toPrecision(12));
    return '$' + corrected.toFixed(2);
  }

  function getHandle(card) {
    var link = card.querySelector('a.boost-sd__product-link, .boost-sd__product-link a, a.boost-sd__product-title-link');
    if (!link) link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function shouldShowRibbon(value) {
    if (value == null) return false;
    var str = String(value).trim();
    if (str === '') return false;
    if (str.toLowerCase() === 'null') return false;
    return true;
  }

  function insertBelowPrice(card, node) {
    var priceArea = card.querySelector('.boost-sd__product-price');
    if (priceArea && priceArea.parentNode) {
      var sibling = priceArea.nextSibling;
      while (sibling && sibling.nodeType === 1 && sibling.classList &&
             (sibling.classList.contains('twc-plp-price-value') || sibling.classList.contains('twc-plp-ribbon'))) {
        sibling = sibling.nextSibling;
      }
      priceArea.parentNode.insertBefore(node, sibling);
      return true;
    }
    var info = card.querySelector('.boost-sd__product-info');
    if (info) { info.appendChild(node); return true; }
    return false;
  }

  function clearInjections(card) {
    card.querySelectorAll('.twc-plp-price-value, .twc-plp-ribbon').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
  }

  function injectRibbon(card, data) {
    if (!shouldShowRibbon(data.ribbon)) return;
    if (card.querySelector('.twc-plp-ribbon')) return;
    var ribbon = document.createElement('div');
    ribbon.className = 'twc-plp-ribbon';
    ribbon.textContent = String(data.ribbon).trim();
    ribbon.style.color = ribbonColor;
    insertBelowPrice(card, ribbon);
  }

  function injectPriceValue(card, data) {
    var bottlePrice = parseFloat(data.bottlePrice);
    if (isNaN(bottlePrice) || bottlePrice <= 0) return;
    if (card.querySelector('.twc-plp-price-value')) return;
    var amount, suffix;
    if (data.inCaseCollection) { amount = bottlePrice * 0.95; suffix = ' in any twelve'; }
    else { amount = bottlePrice; suffix = ' per unit'; }
    var node = document.createElement('div');
    node.className = 'twc-plp-price-value';
    node.innerHTML =
      '<span class="twc-plp-price-value__icon" aria-hidden="true"></span>'
      + '<span class="twc-plp-price-value__text">' + formatMoney(amount) + suffix + '</span>';
    insertBelowPrice(card, node);
  }

  /* ------------------------------------------------------------------------
     Sold out cards.

     Boost's product-item template renders the same enabled "Add to Cart"
     button for every product - it never checks `product.available` - so a sold
     out product otherwise sits on the grid with a working ATC button. The card
     carries its own product JSON in `data-product`, which includes per-variant
     availability, so the state is resolved locally with no extra request. The
     matching pill styling lives in boost-product-cards.css section 18.
     ------------------------------------------------------------------------ */

  // Boost escapes the captured JSON, so a value can arrive as a JSON string
  // wrapping the real object/array. Unwrap at most twice.
  function parseMaybeNested(value) {
    for (var i = 0; i < 2 && typeof value === 'string'; i++) {
      try { value = JSON.parse(value); } catch (e) { return null; }
    }
    return typeof value === 'object' ? value : null;
  }

  function isAvailable(variant) {
    return variant && (variant.available === true || variant.available === 'true');
  }

  function isSoldOut(card, handle) {
    var data = parseMaybeNested(card.getAttribute('data-product'));
    var variants = data ? parseMaybeNested(data.variants) : null;

    if (variants && variants.length) {
      // Split products render one card per variant, so only that variant counts.
      var variantId = data.variantId;
      if (variantId) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) return !isAvailable(variants[i]);
        }
      }
      for (var j = 0; j < variants.length; j++) {
        if (isAvailable(variants[j])) return false;
      }
      return true;
    }

    // Fallback for cards whose data-product cannot be read: the availability
    // pre-rendered by twc-plp-product-data (or lazily fetched below).
    var known = products[handle];
    if (known && typeof known.available === 'boolean') return !known.available;
    return null; // unknown - leave the card alone and re-check on a later pass
  }

  function syncSoldOut(card, handle) {
    var button = card.querySelector('.boost-product-form .product-form__submit');
    if (!button) return;

    var state = card.dataset.twcSoldout;
    if (state == null) {
      var soldOut = isSoldOut(card, handle);
      if (soldOut === null) return;
      state = soldOut ? 'true' : 'false';
      card.dataset.twcSoldout = state;
    }

    var applied = button.dataset.twcSoldout === 'true';
    if (state === 'true' && !applied) {
      button.dataset.twcAtcLabel = button.textContent.trim();
      button.dataset.twcSoldout = 'true';
      button.textContent = SOLD_OUT_LABEL;
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    } else if (state !== 'true' && applied) {
      // Boost reused this DOM node for an in-stock product.
      button.textContent = button.dataset.twcAtcLabel || 'Add to Cart';
      delete button.dataset.twcAtcLabel;
      delete button.dataset.twcSoldout;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }
  }

  /* Safety net for the gap between Boost rendering a card and the observer pass
     that flags it: intercept at the document instead of relying only on the
     button's disabled state. stopPropagation stops the inline
     onclick="globalQuickAdd(event)" from firing; the default action is left
     alone so the click still follows the product link through to the PDP. */
  function blockSoldOutAdd(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.boost-product-form .product-form__submit');
    if (!button) return;
    var card = button.closest('.boost-sd__product-item');
    if (!card) return;
    if (card.dataset.twcSoldout == null) syncSoldOut(card, getHandle(card));
    if (card.dataset.twcSoldout !== 'true') return;
    event.stopPropagation();
  }

  function blockSoldOutSubmit(event) {
    var form = event.target;
    if (!form || !form.closest) return;
    var card = form.closest('.boost-sd__product-item');
    if (!card || card.dataset.twcSoldout !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
  }

  var inFlight = 0;
  var maxInFlight = 2;
  var waitQueue = [];
  function runNext() { if (waitQueue.length) waitQueue.shift()(); }

  function doFetchWithRetry(handle, retry) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=plp-data', { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 429 && retry < 4) {
          var delay = 500 * Math.pow(2, retry);
          return new Promise(function (res) { setTimeout(res, delay); })
            .then(function () { return doFetchWithRetry(handle, retry + 1); });
        }
        if (!r.ok) return null;
        return r.text().then(function (t) {
          try { return JSON.parse(String(t).trim()); } catch (e) { return null; }
        });
      })
      .catch(function () { return null; });
  }

  function fetchProductData(handle) {
    if (fetchPromises[handle]) return fetchPromises[handle];
    fetchPromises[handle] = new Promise(function (resolve) {
      var task = function () {
        inFlight++;
        doFetchWithRetry(handle, 0).then(function (data) {
          inFlight--; runNext(); resolve(data);
        });
      };
      if (inFlight < maxInFlight) task(); else waitQueue.push(task);
    });
    return fetchPromises[handle];
  }

  function enhanceCard(card) {
    if (!card) return;
    var handle = getHandle(card);
    if (!handle) return;

    // Boost may reuse the same card DOM node for a different product after
    // ajax pagination/filter changes. Reset injections when the handle changes.
    if (card.dataset.twcHandle && card.dataset.twcHandle !== handle) {
      clearInjections(card);
      delete card.dataset.twcEnhanced;
      delete card.dataset.twcSoldout;
    }

    // Runs on every pass: the button is rendered by Boost and can appear (or be
    // replaced) after the card node itself. Cheap once the state is resolved.
    syncSoldOut(card, handle);

    // Idempotent fast path.
    if (card.dataset.twcEnhanced === 'true' && card.dataset.twcHandle === handle) return;
    if (card.dataset.twcEnhanced === 'pending' && card.dataset.twcHandle === handle) return;

    card.dataset.twcHandle = handle;

    var data = products[handle];
    if (data) {
      injectPriceValue(card, data);
      injectRibbon(card, data);
      card.dataset.twcEnhanced = 'true';
      return;
    }

    card.dataset.twcEnhanced = 'pending';
    fetchProductData(handle).then(function (fetched) {
      if (getHandle(card) !== handle) return; // card reassigned mid-fetch
      if (fetched) {
        products[handle] = fetched;
        injectPriceValue(card, fetched);
        injectRibbon(card, fetched);
        syncSoldOut(card, handle); // settles cards that fell back to fetched data
      }
      card.dataset.twcEnhanced = 'true';
    });
  }

  function enhanceAll() {
    var cards = document.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < cards.length; i++) enhanceCard(cards[i]);
  }

  // Debounced scheduler. Idempotency in enhanceCard means re-running is cheap.
  var debounceTimer = null;
  function schedule(delay) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      enhanceAll();
    }, delay == null ? 100 : delay);
  }

  // Patch history methods on both the instance and the prototype so callers
  // using either form trigger our re-check. Re-checks fire across a short
  // window to account for the gap between URL change and DOM update.
  function watchHistoryChanges() {
    function trigger() {
      schedule(50);
      setTimeout(enhanceAll, 300);
      setTimeout(enhanceAll, 800);
      setTimeout(enhanceAll, 1500);
    }
    ['pushState', 'replaceState'].forEach(function (m) {
      var instanceOrig = history[m];
      if (typeof instanceOrig === 'function') {
        history[m] = function () {
          var r = instanceOrig.apply(this, arguments);
          trigger();
          return r;
        };
      }
      var protoOrig = History.prototype[m];
      if (typeof protoOrig === 'function' && protoOrig !== history[m]) {
        History.prototype[m] = function () {
          var r = protoOrig.apply(this, arguments);
          trigger();
          return r;
        };
      }
    });
    window.addEventListener('popstate', trigger);
    window.addEventListener('hashchange', trigger);
  }

  // Single body-subtree observer. Debounce + handle-aware idempotency keep
  // this cheap even with frequent app mutations on the page.
  function startObserver() {
    var observer = new MutationObserver(function () { schedule(100); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Note: the mobile add-to-cart tap-feedback spinner is handled purely in CSS
  // (boost-product-cards.css §16). The theme's quick-add (window.globalQuickAdd
  // in global.js) adds a `.loading` class to the button for the duration of the
  // /cart/add request and removes it when the side cart opens, so no JS is
  // needed here.

  function init() {
    enhanceAll();
    startObserver();
    watchHistoryChanges();
    document.addEventListener('click', blockSoldOutAdd, true);
    document.addEventListener('submit', blockSoldOutSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
